module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-recurring-task-checklists-d22077e8240da6063005942237902af9.png";